
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Curtains | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Curtains</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/172.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/C/001</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/173.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/C/002</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/174.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/C/003</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/175.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/C/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/176.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/C/005</h3>
          </article>
      </div>
         </div>
    </section>
  )
}

export default Team